import {useEffect, useRef, useState} from 'react'

import {
  CancellationRequestStatus,
  CancellationRequestStatusValue
} from '../types/cancellationRequest.types'
import {normalizeCancellationRequestStatus} from '../utils/normalizeCancellationRequestStatus'

export const useCancellationPropagationDelay = (
  request: CancellationRequestStatus | null | undefined,
  delayMs: number,
  orderId: string
) => {
  const [isPropagating, setIsPropagating] = useState(false)
  const previousStatusRef = useRef<CancellationRequestStatusValue | undefined>()
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    setIsPropagating(false)
    previousStatusRef.current = undefined
    if (timerRef.current) clearTimeout(timerRef.current)
  }, [orderId])

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [])

  useEffect(() => {
    const status = normalizeCancellationRequestStatus(request?.status)

    if (status === 'completed' && previousStatusRef.current === 'sent') {
      setIsPropagating(true)
      timerRef.current = setTimeout(() => {
        setIsPropagating(false)
        timerRef.current = null
      }, delayMs)
    }

    previousStatusRef.current = status
  }, [delayMs, request?.status])

  return isPropagating
}
